export enum TicketType {
  Paper = 'Paper',
  Card = 'Card',
  ExistingTicket = 'ExistingTicket',
}
